// extracted by mini-css-extract-plugin
module.exports = {"title":"e_Iy","excerpt":"e_Jy","container":"e_Ky","imageContainer":"e_Ly","image":"e_My","postedBy":"e_Ny","postedByDate":"e_Oy"};